import GradientBorderRadius from "@/ui/gradient-border-radius";
import clsx from "clsx";

const ActiveWalletBtn = ({
  onClick,
  active,
}: {
  onClick: () => void;
  active: boolean;
}) => {
  return (
    <button onClick={onClick}>
      <GradientBorderRadius
        gradient="none"
        radius="circle"
        hover="r-100"
        active={undefined}
        className="h-[1.375rem] w-[1.375rem] bg-black rounded-full flex justify-center items-center"
      >
        <div
          className={clsx(
            "w-[0.75rem] h-[0.75rem] rounded-full",
            active ? "bg-teal-500" : "bg-white",
          )}
        ></div>
      </GradientBorderRadius>
    </button>
  );
};

export default ActiveWalletBtn;
